export function debounce< T extends ( ...args: any[] ) => void >( fn: T, delay: number ): ( ...args: Parameters< T > ) => void {
	let timeoutId: ReturnType< typeof setTimeout >

	return ( ...args: Parameters< T > ) => {
		if ( timeoutId ) {
			clearTimeout( timeoutId )
		}

		timeoutId = setTimeout( () => {
			fn( ...args )
		}, delay )
	}
}
